import callApi from './partials/api';
import authorization from "./partials/authorization";
import store from "@/store";

export default {
    // 會員登入
    login({ Account, LoginKey, companyId }, cb, errCb) {
        callApi('post', `Account/Login`, cb, {
            data: {
                Account,
                LoginKey,
                companyId,
            }
        }, errCb);
    },

    // 第三方登入
    oAuth({ Token }, cb) {
        callApi('post', `Account/oAuth`, cb, {
            data: {
                Token,
            }
        });
    },

    // SSO token
    ssoToken({ Key }, cb, errCb) {
        callApi('post', `auth/token`, cb, {
            data: {
                Key,
            }
        }, errCb);
    },

    // SSO Ec token key
    ssoEcTokenKey(cb) {
        if (store.getters['user/Token']) {
            callApi('post', `auth/ec-token-key`, cb, {
                data: {
                    companyId: store.getters['advancedSearch/companyId'],
                },
                ...authorization(),
            });
        } else {
            callApi('post', `auth/ec-token-key`, cb, {
                data: {
                    companyId: store.getters['advancedSearch/companyId'],
                },
            });
        }
    },
}
